

export const hasWindow = () => {
    return Boolean(typeof window !== 'undefined' && window);
}
  